// extracted by mini-css-extract-plugin
export default {"pricingPlans":"pricingPlans___ikR9ouG","plans":"plans___ikR9ouG"};